/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { LoanApplicationMemberDetailedResponsePagedResultDto } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class LoanApplicationMemberService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param keyword 
     * @param statusId 
     * @param loanOfficerUserId 
     * @param branchId 
     * @param groupId 
     * @param status 
     * @param loanStageId 
     * @param skipCount 
     * @param maxResultCount 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiLoanapplicationUserGet(keyword?: string, statusId?: number, loanOfficerUserId?: number, branchId?: number, groupId?: number, status?: string, loanStageId?: number, skipCount?: number, maxResultCount?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<LoanApplicationMemberDetailedResponsePagedResultDto>;
    public apiLoanapplicationUserGet(keyword?: string, statusId?: number, loanOfficerUserId?: number, branchId?: number, groupId?: number, status?: string, loanStageId?: number, skipCount?: number, maxResultCount?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<HttpResponse<LoanApplicationMemberDetailedResponsePagedResultDto>>;
    public apiLoanapplicationUserGet(keyword?: string, statusId?: number, loanOfficerUserId?: number, branchId?: number, groupId?: number, status?: string, loanStageId?: number, skipCount?: number, maxResultCount?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<HttpEvent<LoanApplicationMemberDetailedResponsePagedResultDto>>;
    public apiLoanapplicationUserGet(keyword?: string, statusId?: number, loanOfficerUserId?: number, branchId?: number, groupId?: number, status?: string, loanStageId?: number, skipCount?: number, maxResultCount?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (keyword !== undefined && keyword !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>keyword, 'Keyword');
        }
        if (statusId !== undefined && statusId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>statusId, 'StatusId');
        }
        if (loanOfficerUserId !== undefined && loanOfficerUserId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>loanOfficerUserId, 'LoanOfficerUserId');
        }
        if (branchId !== undefined && branchId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>branchId, 'BranchId');
        }
        if (groupId !== undefined && groupId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>groupId, 'GroupId');
        }
        if (status !== undefined && status !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>status, 'Status');
        }
        if (loanStageId !== undefined && loanStageId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>loanStageId, 'LoanStageId');
        }
        if (skipCount !== undefined && skipCount !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>skipCount, 'SkipCount');
        }
        if (maxResultCount !== undefined && maxResultCount !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>maxResultCount, 'MaxResultCount');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<LoanApplicationMemberDetailedResponsePagedResultDto>(`${this.configuration.basePath}/api/loanapplication/user`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
